const routes = [
  {
    path: '/testimonials',
    name: 'site-testimonials',
    meta: {
      authRequired: true,
      roles: []
    },
    component: () => import('./Index.vue')
  },
  {
    path: '/testimonials/new',
    name: 'site-testimonials-new',
    meta: {
      authRequired: true,
      roles: []
    },
    component: () => import('./Form.vue')
  },
  {
    path: '/testimonials/:id/edit',
    name: 'site-testimonials-edit',
    meta: {
      authRequired: true,
      roles: []
    },
    component: () => import('./Form.vue')
  }
]

export { routes }
export default routes
